import { render } from "./WpFieldInput.vue?vue&type=template&id=8ee73ae8"
import script from "./WpFieldInput.vue?vue&type=script&lang=js"
export * from "./WpFieldInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__